import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';
import { removeMetaFields } from '@/helpers/utils';

export default new (class {
	async updateAreaSettings(object) {
		await graphqlClient.mutate({
			mutation: gql`
				mutation($update: AreaSettingInputObjectGraphType!) {
					updateIgnoreNullValuesAreaSetting(update: $update) {
						id
					}
				}
			`,
			variables: {
				update: object
			}
		});
	}

	async fetchVariables(selectedArea) {
		const { data } = await graphqlClient.query({
			query: gql`
				query getVariablesByArea($where: String!) {
					areaSettings(where: $where) {
						id
						area
						autoLoanInterest
						autoLoanCoefficient
						autoLoanCreditScoreThreshold
						autoLoanDealershipInterest
						autoLoanDealershipCoefficient
						autoLoanDealershipCreditScoreThreshold
						mortgageLoanCreditScoreThreshold
						mortgageLoanHighSaverCoefficient
						mortgageLoanLowSaverCoefficient
						mortgageLoanInterest
					}
				}
			`,
			variables: {
				where: `area =="${selectedArea}"`
			},
			fetchPolicy: 'no-cache'
		});

		if (data.areaSettings.length) {
			return removeMetaFields(data.areaSettings[0]);
		}
	}
})();
